export const triggerCustomEvent = (eventName: string, data: any) => {
	let event;

	if (typeof CustomEvent === "function") {
		event = new CustomEvent(eventName, { detail: data });
	} else {
		event = document.createEvent("CustomEvent");
		event.initCustomEvent(eventName, true, true, data);
	}

	document.dispatchEvent(event);
};
